// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header Styles */
.header {
  background-color: var(--color-secondary);
  position: sticky;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid var(--color-white);
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1500px;
  margin: 0 auto;
  padding: 1rem 2rem;
  min-height: 80px;
}

/* Logo Section */
.header-logo {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: all 0.3s ease;
  border-radius: 4px;
  padding: 0.25rem;
}

.logo-link:hover {
  transform: scale(1.05);
  opacity: 0.8;
}

.logo-image {
  height: 40px;
  width: auto;
  object-fit: contain;
}

/* Tagline Section */
.header-tagline {
  flex: 1 1;
  text-align: center;
  margin: 0 2rem;
}

.header-tagline h1 {
  color: var(--color-text-primary);
  font-size: 1.5rem;
  font-weight: 300;
  margin: 0;
  letter-spacing: 0.5px;
}

/* Hamburger Menu */
.header-menu {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.hamburger {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 24px;
  padding: 0;
  transition: all 0.3s ease;
}

.hamburger:hover {
  transform: scale(1.1);
}

.hamburger-line {
  width: 100%;
  height: 3px;
  background-color: var(--color-primary);
  border-radius: 2px;
  transition: all 0.3s ease;
  transform-origin: center;
}

/* Hamburger Animation when Active */
.hamburger.active .hamburger-line:nth-child(1) {
  transform: rotate(45deg) translate(6px, 6px);
}

.hamburger.active .hamburger-line:nth-child(2) {
  opacity: 0;
}

.hamburger.active .hamburger-line:nth-child(3) {
  transform: rotate(-45deg) translate(6px, -6px);
}

/* Right-Side Navigation Tab */
.navigation-overlay {
  position: fixed;
  top: 0;
  right: 0;
  width: 500px;
  max-width: 90vw;
  height: 100vh;
  background-color: rgba(32, 32, 32, 0.98);
  backdrop-filter: blur(10px);
  z-index: 2000;
  transform: translateX(100%);
  visibility: hidden;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.3);
}

.navigation-overlay-open {
  transform: translateX(0);
  visibility: visible;
}

.navigation-overlay-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 2rem;
}

/* Close Button */
.navigation-close {
  position: absolute;
  top: 2rem;
  right: 2rem;
  background: none;
  border: none;
  color: var(--color-primary);
  font-size: 2rem;
  cursor: pointer;
  z-index: 2001;
  transition: all 0.3s ease;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navigation-close:hover {
  color: var(--color-white);
  transform: scale(1.1);
}

/* Navigation Menu */
.navigation-menu {
  flex: 1 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding-top: 2rem;
}

.navigation-list {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}

.navigation-item {
  margin-bottom: 1.5rem;
}

/* Section Headers (like "WHO WE ARE") */
.navigation-section {
  width: 100%;
}

.navigation-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 0.5rem 0;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.navigation-section-title {
  font-family: var(--font-primary);
  font-size: 2.8rem;
  font-weight: 500;
  color: var(--color-text-primary);
  letter-spacing: 1.5px;
  text-transform: uppercase;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  font-family: var(--font-family-scrolling);
}

.navigation-section-header:hover .navigation-section-title {
  color: var(--color-text-secondary);
}

.navigation-section-header.expanded .navigation-section-indicator {
  transform: scale(1.1);
}

.navigation-section-header.expanded .navigation-section-title {
  transform: translateX(5px);
}

.navigation-section-indicator {
  font-size: 2rem;
  color: var(--color-text-secondary);
  font-weight: 300;
  margin-left: 1rem;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  min-width: 2rem;
  text-align: center;
  transform-origin: center;
}

/* Submenu */
.navigation-submenu {
  list-style: none;
  margin: 0.5rem 0 0 2rem;
  padding: 0;
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transform: translateY(-10px);
  transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.navigation-submenu.expanded {
  max-height: 500px;
  opacity: 1;
  transform: translateY(0);
}

.navigation-subitem {
  margin-bottom: 0.5rem;
}

.navigation-submenu.expanded .navigation-subitem {
  /* All items appear together without staggered delay */
}

.navigation-sublink {
  display: block;
  font-family: var(--font-primary);
  font-size: 1.8rem;
  font-weight: 400;
  color: var(--color-white);
  text-decoration: none;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  transition: all 0.3s ease;
  padding: 0.3rem 0;
  font-family: var(--font-family-scrolling);
}

.navigation-sublink:hover,
.navigation-sublink.active {
  color: var(--color-primary);
  transform: translateX(10px);
}

/* Regular Navigation Links */
.navigation-link-wrapper {
  width: 100%;
}

.navigation-link {
  display: flex;
  flex-direction: column;
  text-decoration: none;
  padding: 0.5rem 0;
  transition: all 0.3s ease;
  cursor: pointer;
}

.navigation-link:hover {
  transform: translateX(10px);
}

.navigation-link-title {
  font-family: var(--font-primary);
  font-size: 2.8rem;
  font-weight: 500;
  color: var(--color-white);
  letter-spacing: 1.5px;
  text-transform: uppercase;
  transition: all 0.3s ease;
  line-height: 1.2;
  font-family: var(--font-family-scrolling);
}

.navigation-link:hover .navigation-link-title,
.navigation-link.active .navigation-link-title {
  color: var(--color-primary);
}

.navigation-link-subtitle {
  font-family: var(--font-primary);
  font-size: 1rem;
  font-weight: 300;
  color: var(--color-primary);
  letter-spacing: 0.8px;
  margin-top: 0.1rem;
  transition: all 0.3s ease;
}

.navigation-link:hover .navigation-link-subtitle {
  color: var(--color-white);
}

/* Responsive Design */
@media (max-width: 768px) {
  .header-container {
    padding: 1rem;
  }
  
  .header-tagline {
    display: none;
  }

  .navigation-overlay {
    width: 100vw;
    max-width: 100vw;
  }

  .navigation-overlay-content {
    padding: 1rem;
  }

  .navigation-close {
    top: 1rem;
    right: 1rem;
    font-size: 1.5rem;
  }

  .navigation-menu {
    padding-top: 1.5rem;
  }

  .navigation-section-title,
  .navigation-link-title {
    font-size: 2.5rem;
    letter-spacing: 1px;
  }

  .navigation-sublink {
    font-size: 1.4rem;
  }

  .navigation-link-subtitle {
    font-size: 0.9rem;
  }

  .navigation-item {
    margin-bottom: 1.2rem;
  }
}

@media (max-width: 480px) {
  .navigation-section-title,
  .navigation-link-title {
    font-size: 1.9rem;
  }

  .navigation-sublink {
    font-size: 1.2rem;
  }

  .navigation-link-subtitle {
    font-size: 0.8rem;
  }

  .navigation-submenu {
    margin-left: 1rem;
  }

  .navigation-section-indicator {
    font-size: 1.3rem;
  }

  .navigation-submenu {
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  .navigation-item {
    margin-bottom: 1rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,wCAAwC;EACxC,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,yCAAyC;EACzC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sCAAsC;EACtC,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,oCAAoC;AACpC;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,aAAa;EACb,wCAAwC;EACxC,2BAA2B;EAC3B,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,qDAAqD;EACrD,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,qDAAqD;AACvD;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;EACzB,qDAAqD;EACrD,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,qDAAqD;EACrD,eAAe;EACf,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,4BAA4B;EAC5B,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;;EAEE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;;IAEE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qDAAqD;EACvD;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Header Styles */\n.header {\n  background-color: var(--color-secondary);\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  border-bottom: 1px solid var(--color-white);\n}\n\n.header-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 1500px;\n  margin: 0 auto;\n  padding: 1rem 2rem;\n  min-height: 80px;\n}\n\n/* Logo Section */\n.header-logo {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.logo-link {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  border-radius: 4px;\n  padding: 0.25rem;\n}\n\n.logo-link:hover {\n  transform: scale(1.05);\n  opacity: 0.8;\n}\n\n.logo-image {\n  height: 40px;\n  width: auto;\n  object-fit: contain;\n}\n\n/* Tagline Section */\n.header-tagline {\n  flex: 1;\n  text-align: center;\n  margin: 0 2rem;\n}\n\n.header-tagline h1 {\n  color: var(--color-text-primary);\n  font-size: 1.5rem;\n  font-weight: 300;\n  margin: 0;\n  letter-spacing: 0.5px;\n}\n\n/* Hamburger Menu */\n.header-menu {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.hamburger {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  width: 30px;\n  height: 24px;\n  padding: 0;\n  transition: all 0.3s ease;\n}\n\n.hamburger:hover {\n  transform: scale(1.1);\n}\n\n.hamburger-line {\n  width: 100%;\n  height: 3px;\n  background-color: var(--color-primary);\n  border-radius: 2px;\n  transition: all 0.3s ease;\n  transform-origin: center;\n}\n\n/* Hamburger Animation when Active */\n.hamburger.active .hamburger-line:nth-child(1) {\n  transform: rotate(45deg) translate(6px, 6px);\n}\n\n.hamburger.active .hamburger-line:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger.active .hamburger-line:nth-child(3) {\n  transform: rotate(-45deg) translate(6px, -6px);\n}\n\n/* Right-Side Navigation Tab */\n.navigation-overlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 500px;\n  max-width: 90vw;\n  height: 100vh;\n  background-color: rgba(32, 32, 32, 0.98);\n  backdrop-filter: blur(10px);\n  z-index: 2000;\n  transform: translateX(100%);\n  visibility: hidden;\n  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n  box-shadow: -10px 0 30px rgba(0, 0, 0, 0.3);\n}\n\n.navigation-overlay-open {\n  transform: translateX(0);\n  visibility: visible;\n}\n\n.navigation-overlay-content {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 2rem;\n}\n\n/* Close Button */\n.navigation-close {\n  position: absolute;\n  top: 2rem;\n  right: 2rem;\n  background: none;\n  border: none;\n  color: var(--color-primary);\n  font-size: 2rem;\n  cursor: pointer;\n  z-index: 2001;\n  transition: all 0.3s ease;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.navigation-close:hover {\n  color: var(--color-white);\n  transform: scale(1.1);\n}\n\n/* Navigation Menu */\n.navigation-menu {\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n  padding-top: 2rem;\n}\n\n.navigation-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n}\n\n.navigation-item {\n  margin-bottom: 1.5rem;\n}\n\n/* Section Headers (like \"WHO WE ARE\") */\n.navigation-section {\n  width: 100%;\n}\n\n.navigation-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  padding: 0.5rem 0;\n  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n\n.navigation-section-title {\n  font-family: var(--font-primary);\n  font-size: 2.8rem;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n  font-family: var(--font-family-scrolling);\n}\n\n.navigation-section-header:hover .navigation-section-title {\n  color: var(--color-text-secondary);\n}\n\n.navigation-section-header.expanded .navigation-section-indicator {\n  transform: scale(1.1);\n}\n\n.navigation-section-header.expanded .navigation-section-title {\n  transform: translateX(5px);\n}\n\n.navigation-section-indicator {\n  font-size: 2rem;\n  color: var(--color-text-secondary);\n  font-weight: 300;\n  margin-left: 1rem;\n  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n  min-width: 2rem;\n  text-align: center;\n  transform-origin: center;\n}\n\n/* Submenu */\n.navigation-submenu {\n  list-style: none;\n  margin: 0.5rem 0 0 2rem;\n  padding: 0;\n  max-height: 0;\n  opacity: 0;\n  overflow: hidden;\n  transform: translateY(-10px);\n  transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n\n.navigation-submenu.expanded {\n  max-height: 500px;\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.navigation-subitem {\n  margin-bottom: 0.5rem;\n}\n\n.navigation-submenu.expanded .navigation-subitem {\n  /* All items appear together without staggered delay */\n}\n\n.navigation-sublink {\n  display: block;\n  font-family: var(--font-primary);\n  font-size: 1.8rem;\n  font-weight: 400;\n  color: var(--color-white);\n  text-decoration: none;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  transition: all 0.3s ease;\n  padding: 0.3rem 0;\n  font-family: var(--font-family-scrolling);\n}\n\n.navigation-sublink:hover,\n.navigation-sublink.active {\n  color: var(--color-primary);\n  transform: translateX(10px);\n}\n\n/* Regular Navigation Links */\n.navigation-link-wrapper {\n  width: 100%;\n}\n\n.navigation-link {\n  display: flex;\n  flex-direction: column;\n  text-decoration: none;\n  padding: 0.5rem 0;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.navigation-link:hover {\n  transform: translateX(10px);\n}\n\n.navigation-link-title {\n  font-family: var(--font-primary);\n  font-size: 2.8rem;\n  font-weight: 500;\n  color: var(--color-white);\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  transition: all 0.3s ease;\n  line-height: 1.2;\n  font-family: var(--font-family-scrolling);\n}\n\n.navigation-link:hover .navigation-link-title,\n.navigation-link.active .navigation-link-title {\n  color: var(--color-primary);\n}\n\n.navigation-link-subtitle {\n  font-family: var(--font-primary);\n  font-size: 1rem;\n  font-weight: 300;\n  color: var(--color-primary);\n  letter-spacing: 0.8px;\n  margin-top: 0.1rem;\n  transition: all 0.3s ease;\n}\n\n.navigation-link:hover .navigation-link-subtitle {\n  color: var(--color-white);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .header-container {\n    padding: 1rem;\n  }\n  \n  .header-tagline {\n    display: none;\n  }\n\n  .navigation-overlay {\n    width: 100vw;\n    max-width: 100vw;\n  }\n\n  .navigation-overlay-content {\n    padding: 1rem;\n  }\n\n  .navigation-close {\n    top: 1rem;\n    right: 1rem;\n    font-size: 1.5rem;\n  }\n\n  .navigation-menu {\n    padding-top: 1.5rem;\n  }\n\n  .navigation-section-title,\n  .navigation-link-title {\n    font-size: 2.5rem;\n    letter-spacing: 1px;\n  }\n\n  .navigation-sublink {\n    font-size: 1.4rem;\n  }\n\n  .navigation-link-subtitle {\n    font-size: 0.9rem;\n  }\n\n  .navigation-item {\n    margin-bottom: 1.2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .navigation-section-title,\n  .navigation-link-title {\n    font-size: 1.9rem;\n  }\n\n  .navigation-sublink {\n    font-size: 1.2rem;\n  }\n\n  .navigation-link-subtitle {\n    font-size: 0.8rem;\n  }\n\n  .navigation-submenu {\n    margin-left: 1rem;\n  }\n\n  .navigation-section-indicator {\n    font-size: 1.3rem;\n  }\n\n  .navigation-submenu {\n    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n  }\n\n  .navigation-item {\n    margin-bottom: 1rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
